import { createStore, combineReducers, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import { composeWithDevTools } from "@redux-devtools/extension";
import { DashboardDataGetReducer, DashboardRedirectionReducer } from "./Redux/Reducer/CommonReducer";
import {
  AdminChangePasswordReducer,
  AdminLogInReducer,
  AdminResendOtpReducer,
  AdminUpdateProfileReducer,
  DetailAdminProfileReducer,
  ForgotPasswordReducer,
  LogoutReducer,
  ResetPasswordReducer,
  UpdateAdminProfileReducer,
} from "./Redux/Reducer/AuthReducer";



import {
  CmsDetailReducer,
  CmsGetReducer,
  CmsUpdateReducer,
} from "./Redux/Reducer/CmsReducer";

import { CustomerGetReducer, CustomerStatusGetReducer, CustomerDetailsGetReducer } from "./Redux/Reducer/CustomerReducer";
import { CategoryGetReducer, CategoryAddReducer, CategoryStatusReducer  , CategoryDeleteReducer, CategoryDetailsReducer, CategoryUpdateReducer } from "./Redux/Reducer/Category";
import {ServiceGetReducer, ServiceCategoryReducer, ServiceDetailsReducer, ServiceStatusReducer } from "./Redux/Reducer/ServiceReducer";
import { SalonDetailGetReducer, SalonGetReducer, SalonStatusGetReducer,SalonUpdateReducer , SalonApprovedStatusGetReducer ,SalonBussianImageGetReducer , SalonDeleteReducer, SalonSubscriptionManageReducer } from "./Redux/Reducer/SalonReducer.";
import { StaffGetReducer } from "./Redux/Reducer/StaffReducer";
import { ContactListReducer, ContactDetailsReducer, ContactStatusReducer } from "./Redux/Reducer/ContactReducer";
import { FaqGetReducer, FaqCreateReducer, FaqStatusReducer ,FaqUpdateReducer , FaqDetailsReducer , FaqDeleteReducer } from "./Redux/Reducer/FaqReducer";
import { AtributeGetReducer , AtributeCreateReducer , AtributeDetailsReducer , AtributeStatusReducer , AtributeUpdateReducer } from "./Redux/Reducer/AtributeReducer";
import { BookingGetReducer , BookingDetailReducer } from "./Redux/Reducer/BookingReducer";
import {EmailTemplateGetReducer , EmailTemplateDetailsReducer ,EmailTemplateUpdateReducer} from './Redux/Reducer/EmailTemplateReducer'
import { ReviewGetReducer  , ReviewDeleteReducer } from "./Redux/Reducer/ReviewReducer";
import { NotificationReducer ,NotificationAddReducer} from "./Redux/Reducer/NotificationReducer";
import {
  SubscriptionPlanListReducer,
  SubscriptionPlanDetailsReducer,
  SubscriptionPlanUpdateReducer,
} from "./Redux/Reducer/SubscriptionPlanReducer";
import {
  SubscriptionPaymentListReducer,
  SubscriptionPaymentApproveReducer,
  SubscriptionPaymentRejectReducer,
  OfflineBankSettingsGetReducer,
  OfflineBankSettingsUpdateReducer,
} from "./Redux/Reducer/SubscriptionPaymentReducer";

const reducer = combineReducers({
  // Dashboard
  DashboardDataGetState: DashboardDataGetReducer,
  DashboardRedirectionState: DashboardRedirectionReducer,

  // Auth
  AdminLogInState: AdminLogInReducer,
  ForgotPasswordState: ForgotPasswordReducer,
  ResetPasswordState: ResetPasswordReducer,
  AdminChangePasswordState: AdminChangePasswordReducer,
  LogoutState: LogoutReducer,
  UpdateAdminProfileState: UpdateAdminProfileReducer,
  DetailAdminProfileState: DetailAdminProfileReducer,
  AdminProfileUpdateState: AdminUpdateProfileReducer,
  AdminResendOtpState: AdminResendOtpReducer,


  // Cms Pages
  CmsGetState: CmsGetReducer,
  CmsDetailState: CmsDetailReducer,
  CmsUpdateState: CmsUpdateReducer,

  // Customer pages
  CustomerGetState: CustomerGetReducer,
  CustomerStatusState: CustomerStatusGetReducer,
  CustomerDetailsState: CustomerDetailsGetReducer,

  // Catgory Pages
  CategoryGetState: CategoryGetReducer,
  CategoryAddState: CategoryAddReducer,
  categoryStatusState: CategoryStatusReducer,
  CategoryDeleteState:CategoryDeleteReducer,
  CategoryDetailsState:CategoryDetailsReducer,
  CategoryUpdateState:CategoryUpdateReducer,
  // Service Pages
  SeriveGetState: ServiceGetReducer,
  ServiceCategoryState: ServiceCategoryReducer,
  ServiceDetailsState: ServiceDetailsReducer,
  ServiceStatusState: ServiceStatusReducer,

  // Salon Pages
  SalonGetState: SalonGetReducer,
  SalonDetailGetState: SalonDetailGetReducer,
  SalonStatusGetState: SalonStatusGetReducer,
  SalonApprovedStatusGetState: SalonApprovedStatusGetReducer,
  SalonBussianImageGetState:SalonBussianImageGetReducer,
  SalonUpdateState:SalonUpdateReducer,
  SalonDeleteState:SalonDeleteReducer,
  SalonSubscriptionManageState: SalonSubscriptionManageReducer,

  //  Staff pages
  StaffGetState: StaffGetReducer,

  //Contact Us pages
  Contact_Us_GetState: ContactListReducer,
  ContactDetailsState: ContactDetailsReducer,
  ContactStatusState: ContactStatusReducer,

  // Faq pages
  FaqGetstate: FaqGetReducer,
  FaqCreatestate: FaqCreateReducer,
  FaqStatusstate: FaqStatusReducer,
  FaqUpdateState :FaqUpdateReducer ,
  FaqDetailsState : FaqDetailsReducer,
  FaqDeleteState:FaqDeleteReducer,

  // Atribute pages
  AtributeGetState:AtributeGetReducer,
  AtributeCreateState:AtributeCreateReducer,
  AtributeDetailsState:AtributeDetailsReducer,
  AtributeStatusState:AtributeStatusReducer,
  AtributeUpdateState:AtributeUpdateReducer,

  // Booking pages
  BookingGetState:BookingGetReducer,
  BookingDetailState:BookingDetailReducer,

  // Email template 
  EmailTemplateGetState:EmailTemplateGetReducer,
  EmailTemplateDetailsState:EmailTemplateDetailsReducer,
  EmailTemplateUpdateState:EmailTemplateUpdateReducer,

  // Review Rating template 
  ReviewGetState:ReviewGetReducer,
  ReviewDeleteState:ReviewDeleteReducer,


  //Notification page
  NotificationState:NotificationReducer,
  NotificationAddState:NotificationAddReducer,

  // Offline subscription plans
  SubscriptionPlanListState: SubscriptionPlanListReducer,
  SubscriptionPlanDetailsState: SubscriptionPlanDetailsReducer,
  SubscriptionPlanUpdateState: SubscriptionPlanUpdateReducer,

  SubscriptionPaymentListState: SubscriptionPaymentListReducer,
  SubscriptionPaymentApproveState: SubscriptionPaymentApproveReducer,
  SubscriptionPaymentRejectState: SubscriptionPaymentRejectReducer,
  OfflineBankSettingsGetState: OfflineBankSettingsGetReducer,
  OfflineBankSettingsUpdateState: OfflineBankSettingsUpdateReducer,

});

let initialState = {};
const middleware = [thunk];
const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);
export default store;
